import type { IInputDuree } from '@designSystem/components'
import { isNullOrUndefined } from '@/features/shared/tools'

export function floatToInputDuree(duree: string | number | null | undefined): IInputDuree | null {
  if (typeof duree === 'string') {
    return {
      heure: duree,
      minute: null
    }
  }
  else if (typeof duree === 'number') {
    const heure = Math.floor(duree)
    const minute = Math.round((duree % 1) * 60)
    return { heure, minute }
  }
  return null
}

export function inputDureeToFloat(duree: IInputDuree | null | undefined): number | string | null {
  let data: any = null
  if (isNullOrUndefined(duree)) {}
  else if (typeof duree.heure === 'string')
    data = duree.heure
  else if (typeof duree.heure === 'number') {
    const minutes = typeof duree.minute === 'number' ? duree.minute : 0
    const partieMinutes = Math.round((minutes * 100) / 60) / 100
    data = duree.heure + partieMinutes
  }
  return data
}
